import { Box, Button, Grid2, IconButton, Paper, useTheme } from "@mui/material";
import { useSideScreen } from "../Layout/backoffice";
import capitalizeFirstLetter from "../helpers/capitalizeFirstLetter";
import selectionQueryCreator from "./selectionQueryCreator";
import { gql, useQuery } from "@apollo/client";
import { useState } from "react";
import Loader from "./Loader";
import { Close } from "@mui/icons-material";
import Text from "./Text";

const SingleSelectionInput = ({ onSelectionChanged, propertyName, values }) => {

    const onSelected = (item) => {
        onSelectionChanged(item.uuid);
        setSelectedValues(item.uuid);
    }

    const { openSelectionSideScreen } = useSideScreen();
    const entityType = propertyName.slice(0, -2);
    const [selectedValues, setSelectedValues] = useState(values);
    const SELECTION_QUERY = selectionQueryCreator(entityType);
    const theme = useTheme();
    const { data, loading } = useQuery(gql(SELECTION_QUERY),
        { variables: { ids: [selectedValues] } }
    )
    if (loading) {
        return <Loader text={"Loading Data..."} />
    }
    let text;

    if (data) {
        text = Object.values(data)[0][0].displayName
    } else {
        text = "Select " + capitalizeFirstLetter(entityType);
    }

    return (
        <Grid2 sx={{
            cursor: "pointer",
            borderRadius: 1,
            border: "1px solid #444",
            '&:hover': {
                borderColor: '#ddd',
            },
        }}
            alignItems={"center"}
            justifyContent={"space-between"} direction={"row"} container size={12}>
            <Grid2 sx={{ flexGrow: 1, m: 1 }} onClick={() => openSelectionSideScreen(entityType, onSelected)}>
                <Text text={text} />
            </Grid2>
            <Grid2 sx={{ pr: 1 }}>
                <IconButton onClick={() => setSelectedValues(null)} >
                    <Close />
                </IconButton>
            </Grid2>
        </Grid2>

    )
}
export default SingleSelectionInput;